import { render, staticRenderFns } from "./potentialClientDetails.vue?vue&type=template&id=3f74f634&scoped=true&"
import script from "./potentialClientDetails.vue?vue&type=script&lang=js&"
export * from "./potentialClientDetails.vue?vue&type=script&lang=js&"
import style0 from "./potentialClientDetails.vue?vue&type=style&index=0&id=3f74f634&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74f634",
  null
  
)

export default component.exports